import { useCallback, useState } from "react";

interface AvatarOffset {
  x: number;
  y: number;
  z: number;
}

interface AvatarRotation {
  x: number;
  y: number;
  z: number;
}

export const useAvatarControls = () => {
  const [avatarOffsets, setAvatarOffsets] = useState<
    Record<string, AvatarOffset>
  >({});
  const [avatarRotations, setAvatarRotations] = useState<
    Record<string, AvatarRotation>
  >({});

  const handleAvatarOffsetChange = useCallback(
    (movementId: string, axis: string, value: number) => {
      setAvatarOffsets((prev) => ({
        ...prev,
        [movementId]: {
          ...(prev[movementId] || { x: 0, y: 0, z: 0 }),
          [axis]: value,
        },
      }));
    },
    [],
  );

  const handleAvatarRotationChange = useCallback(
    (movementId: string, axis: string, value: number) => {
      setAvatarRotations((prev) => ({
        ...prev,
        [movementId]: {
          ...(prev[movementId] || { x: 0, y: 0, z: 0 }),
          [axis]: value,
        },
      }));
    },
    [],
  );

  const handleResetAvatarPosition = useCallback((movementId: string) => {
    setAvatarOffsets((prev) => ({
      ...prev,
      [movementId]: { x: 0, y: 0, z: 0 },
    }));
  }, []);

  const handleResetAvatarRotation = useCallback((movementId: string) => {
    setAvatarRotations((prev) => ({
      ...prev,
      [movementId]: { x: 0, y: 0, z: 0 },
    }));
  }, []);

  const handleResetAllAvatar = useCallback((movementId: string) => {
    setAvatarOffsets((prev) => ({
      ...prev,
      [movementId]: { x: 0, y: 0, z: 0 },
    }));
    setAvatarRotations((prev) => ({
      ...prev,
      [movementId]: { x: 0, y: 0, z: 0 },
    }));
  }, []);

  return {
    avatarOffsets,
    avatarRotations,
    handleAvatarOffsetChange,
    handleAvatarRotationChange,
    handleResetAvatarPosition,
    handleResetAvatarRotation,
    handleResetAllAvatar,
  };
};
